import { render, staticRenderFns } from "./SubCategoryMark.vue?vue&type=template&id=1a4ecbd6&"
import script from "./SubCategoryMark.vue?vue&type=script&lang=js&"
export * from "./SubCategoryMark.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoryMark.vue?vue&type=style&index=0&id=1a4ecbd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports